export default "__VITE_ASSET__3mfFwpa0__"